import { TableColumn } from "../../types";
import { Tooltip } from "../../../../components/Tooltip";
import { Tag } from "antd";

const tagsDefault = { id: "tags", label: "Tags" };
export function TagsColumn<TData extends { tags?: { [_: string]: any } }>(
  column: Partial<TableColumn<TData>> = tagsDefault,
) {
  const preset: TableColumn<TData> = {
    ...tagsDefault,
    enableResize: true,
    enableHide: true,
    size: 300,
    cell: (p) => {
      const item = p.row.original;
      const tags = item.tags || {};
      return (
        <div className="flex items-center">
          {Object.values(tags).length > 0 ? (
            <Tooltip
              title={() => {
                return (
                  <div className="flex flex-wrap gap-1" style={{ minWidth: "max-content" }}>
                    {Object.entries(tags).map(([key, value]) => (
                      <Tag key={key}>
                        {key}
                        {String(value || "").length > 0 ? "=" : ""}
                        {String(value || "")}
                      </Tag>
                    ))}
                  </div>
                );
              }}
            >
              <div style={{ minWidth: "max-content" }} className="inline color-link mr-2">
                {Object.values(tags).length} Tags
              </div>
            </Tooltip>
          ) : (
            <span>No Tags</span>
          )}
          {Object.entries(tags).map(([key, value]) => (
            <Tag key={key} style={{ minWidth: 100, maxWidth: 250 }}>
              {key}
              {String(value || "").length > 0 ? "=" : ""}
              {String(value || "")}
            </Tag>
          ))}
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
